/*
 *  -----------------------------------------------------------------------
 *    <copyright file="study-summary.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export const STUDY_SUMMARY_GRIDS = {
    risk: 'risk',
    site: 'site',
    study: 'study',
};

export const OVERVIEW_TABLE_CONFIG_TITLE = 'HeaderTitles';
